import { Routes, Route } from "react-router-dom";
import WebsiteLayout from "./layouts/WebsiteLayout";
import Home from "./website/pages/Home.jsx";
import About from "./website/pages/About.jsx";
import PanelLayout from "./layouts/PanelLayout.jsx";
import Gallery from "./website/pages/Gallery.jsx";
import Contact from "./website/pages/Contact.jsx";
import Blogs from "./website/pages/Blogs.jsx";
import Faq from "./website/pages/Faq.jsx";
import AllCourses from "./website/pages/courses/AllCourses.jsx";
import MasterCourses from "./website/pages/courses/MasterCourses.jsx";
import WeekendCourses from "./website/pages/courses/WeekendCourses.jsx";
import Login from "./panel/auth/Login.jsx";
import Dashboard from "./panel/pages/Dashboard.jsx";
import ActivatePackage from "./panel/pages/ActivatePackage.jsx";
import FundRequest from "./panel/pages/FundRequest.jsx";
import QuickDeposit from "./panel/pages/QuickDeposit.jsx";
import PrivacyPolicy from "./website/pages/PrivacyPolicy.jsx";
import MyCourses from "./panel/pages/MyCourses.jsx";
import Wallets from "./panel/pages/Wallets.jsx";
import TeamReports from "./panel/pages/TeamReports.jsx";
import Profile from "./panel/pages/Profile.jsx";
import ComplainList from "./panel/pages/ComplainList.jsx";
import CreateComplain from "./panel/pages/CreateComplain.jsx";

function App() {
  return (
    <>
      <Routes>
        <Route element={<WebsiteLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/faqs" element={<Faq />} />
          <Route path="/all_courses" element={<AllCourses />} />
          <Route path="/master_courses" element={<MasterCourses />} />
          <Route path="/weekend_courses" element={<WeekendCourses />} />
          <Route path="/privacy_policy" element={<PrivacyPolicy />} />
        </Route>

        <Route path="/panel" element={<PanelLayout />}>
          <Route path="login" element={<Login />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="activate_package" element={<ActivatePackage />} />
          <Route path="quick_deposit" element={<QuickDeposit />} />
          <Route path="manual_deposit" element={<FundRequest />} />
          <Route path="courses" element={<MyCourses />} />
          <Route path="wallets" element={<Wallets />} />
          <Route path="team_reports" element={<TeamReports />} />
          <Route path="profile" element={<Profile />} />
          <Route path="complain_list" element={<ComplainList />} />
          <Route path="create_complain" element={<CreateComplain />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
